const SDK_VERSION = "10.57.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
